import { createI18n } from 'vue-i18n'
import { appConfig} from '@/utils/config'
import en from './en.json'
import zhCn from './zh-cn.json'
import zhHk from './zh-hk.json'

const i18n = createI18n({
  legacy: false,  // 使用 Composition API 模式
  locale: appConfig.locals,   // 默认语言
  messages: {
    en,
    zhCn,
    zhHk
  }
})

export default i18n
